import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import './styles/site-tokens.css'
import './styles/site.css'
import App from './App.tsx'
import { QueryProvider } from './providers/QueryProvider.tsx'
import { installGlobalErrorReporters } from './utils/clientErrorReporter'

installGlobalErrorReporters()

// Log de arranque en desarrollo: si ves esto en la consola del navegador, el modo dev está activo
const _dev = typeof import.meta !== 'undefined' && import.meta.env?.DEV === true
if (_dev) {
   
  console.log('[migro-hiring] Modo desarrollo – carga OK | DEV:', import.meta.env.DEV, '| MODE:', import.meta.env.MODE)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </StrictMode>,
)
